
import mediaPlugin from './mediaPlugin'

export { insertMedia } from './mediaPluginHelpers'
export { resolveFromURL } from './mediaTypes'
export default mediaPlugin
